import getSharingLinkInfo from './getSharingLinkInfo';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { SharingData } from 'owa-sharing-data';

export default function getSharingData(linkId: string): SharingData | null {
    const sharingLink: SharingLinkInfo = getSharingLinkInfo(linkId);

    if (!!sharingLink) {
        return {
            id: sharingLink.linkId,
            name: sharingLink.fileName,
            supportsDownsell: false, // Creating a classic attachment from a link in the body is not supported.
            currentPermissionLevel: sharingLink.permissionLevel,
            sharingInfo: sharingLink.sharingInfo,
            sharingTipsIgnored: sharingLink.sharingTipsIgnored,
            sharingRecipientsInfo: sharingLink.sharingRecipientsInfo,
        };
    }

    return null;
}
